import { Component, HostListener, ViewChild } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import emailjs, { type EmailJSResponseStatus } from '@emailjs/browser';
import { NgForm } from '@angular/forms';
import { Renderer2 } from '@angular/core';
import jQuery from 'jquery';
const $ = jQuery;

@Component({
  selector: 'app-home-seven',
  templateUrl: './home-seven.component.html',
  styleUrl: './home-seven.component.scss'
})
export class HomeSevenComponent {

  currentYear = new Date().getFullYear();

  formData = {
    user_name: '',
    user_email: '',
    enterprise: '',
    telephone: '',
    message: ''
  };
  
  constructor(private renderer: Renderer2) { }
  
  isSubmitting = false;
  formSubmitted = false;
  submissionSuccess = false;
  submissionError = '';
  
  sendEmail(event: Event) {
    event.preventDefault();
    
    // Set formSubmitted to true to trigger validation styling
    this.formSubmitted = true;
    
    // If form is invalid, don't proceed
    if (this.contactForm.invalid) {
      return;
    }
    
    this.isSubmitting = true;
    this.submissionError = '';
    this.formSubmitted = false; // Reset to prevent red validation styling
    
    // Create the form data to send
    const formData = new FormData();
    
    // Add your Web3Forms access key (get this from your Web3Forms dashboard)
    formData.append('access_key', '9d6b2091-9abc-4198-a8ed-f810315b92fe'); 
    
    // Add form fields
    formData.append('name', this.formData.user_name);
    formData.append('email', this.formData.user_email);
    formData.append('enterprise', this.formData.enterprise || 'Non spécifié');
    formData.append('telephone', this.formData.telephone || 'Non spécifié');
    formData.append('message', this.formData.message);
    
    // Optional: add a subject
    formData.append('subject', 'Nouveau message de contact de ' + this.formData.user_name);
    
    // Send the form using Fetch API
    fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      body: formData
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Erreur réseau');
      }
      return response.json();
    })
    .then(data => {
      this.isSubmitting = false;
      
      if (data.success) {
        // Don't set formSubmitted to true - this prevents red validation styling
        // Instead, add a separate success flag
        this.submissionSuccess = true;
        
        // Keep the form values but don't trigger validation styling
        const currentValues = {...this.formData};
        
        // After successful submission, clear all validation states
        if (this.contactForm) {
          Object.keys(this.contactForm.controls).forEach(key => {
            const control = this.contactForm.controls[key];
            control.markAsUntouched();
            control.markAsPristine();
          });
        }
        
        // After 5 seconds, fully reset the form for a new submission
        setTimeout(() => {
          this.resetForm();
        }, 5000);
      } else {
        this.formSubmitted = true; // Only show validation styling on error
        this.submissionError = 'Une erreur est survenue lors de l\'envoi de votre message. Veuillez réessayer.';
      }
    })
    .catch(error => {
      console.error('Erreur:', error);
      this.isSubmitting = false;
      this.submissionError = 'Une erreur est survenue lors de l\'envoi de votre message. Veuillez réessayer.';
    });
  }
  
  @ViewChild('contactForm') contactForm!: NgForm;
  
  resetForm() {
    // Reset the form completely
    if (this.contactForm) {
      this.contactForm.resetForm();
    }
    
    this.formData = {
      user_name: '',
      user_email: '',
      enterprise: '',
      telephone: '',
      message: ''
    };
    
    this.formSubmitted = false;
    this.submissionSuccess = false;
    this.submissionError = '';
  }

  // UPDATED: Changed banner image path
  bannerImageUrl: string = 'assets/images/banner11.webp';

  // Type it
  phrases: string[] = ['Stratégie', 'Marketing', 'Design', 'Impression', 'Production','Développement']; 
  displayedText: string = ''; 
  currentPhraseIndex: number = 0; 
  currentIndex: number = 0; 
  typingSpeed: number = 100; 
  delayBetweenPhrases: number = 1500; 

  ngOnInit(): void {
    this.updateHasMoreProjects();
    this.startTyping();
  }

  startTyping(): void {
    this.typePhrase();
  }

  typePhrase(): void {
    const phrase = this.phrases[this.currentPhraseIndex];

    const typingInterval = setInterval(() => {
      if (this.currentIndex < phrase.length) {
        this.displayedText += phrase.charAt(this.currentIndex);
        this.currentIndex++;
      } else {
        clearInterval(typingInterval);
        setTimeout(() => {
          this.startDeleting();
        }, this.delayBetweenPhrases); // Delay before starting to delete
      }
    }, this.typingSpeed);
  }

  startDeleting(): void {
    const deletingInterval = setInterval(() => {
      if (this.currentIndex > 0) {
        this.displayedText = this.displayedText.slice(0, -1);
        this.currentIndex--;
      } else {
        clearInterval(deletingInterval);
        this.currentPhraseIndex = (this.currentPhraseIndex + 1) % this.phrases.length;
        this.currentIndex = 0;
        setTimeout(() => {
          this.typePhrase();
        }, this.delayBetweenPhrases); // Delay before starting to type the next phrase
      }
    }, this.typingSpeed / 2); // Faster deleting speed
  }

  // Features
  guarantees = [
    {
      featureBox: "feature-box text-center xs-mb-30 purple-bg center-feature white-color border-radius-25",
      icon: "fas fa-rocket font-40px",
      title: "Site web lancé en 30 jours ou moins",
      desc: "Création et déploiement de votre site web professionnel, optimisé et responsive en moins de 30 jours garantis."
    },
    {
      featureBox: "feature-box text-center xs-mb-30 purple-bg center-feature white-color border-radius-25",
      icon: "fas fa-headset font-40px",
      title: "30 jours de support technique",
      desc: "Support technique gratuit après le lancement de votre site ou campagne pour assurer votre succès digital."
    },
    {
      featureBox: "feature-box text-center xs-mb-30 purple-bg center-feature white-color border-radius-25",
      icon: "fas fa-laptop font-40px",
      title: "30 minutes de formation gratuite",
      desc: "Session de formation et consultation sur votre stratégie de marketing digital et présence sur les réseaux sociaux."
    }
  ];
  
  features =[
    {
      featureBox: "feature-box text-center xs-mb-30 feature-box-gradient-four center-feature white-color border-radius-25",
      icon: "icon-laptop font-40px",
      title: "Friendly Codes",
      desc:"Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    },
    {
      featureBox: "feature-box text-center xs-mb-30 feature-box-gradient-four center-feature white-color border-radius-25",
      icon: "icon-globe font-40px",
      title: "SEO Optimized",
      desc:"Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    },
    {
      featureBox: "feature-box text-center xs-mb-30 feature-box-gradient-four center-feature white-color border-radius-25",
      icon: "icon-dial font-40px",
      title: "Fast Support",
      desc:"Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    },
    {
      featureBox: "feature-box text-center xs-mb-30 feature-box-gradient-four center-feature white-color border-radius-25",
      icon: "icon-dial font-40px",
      title: "Fast Support",
      desc:"Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    }
  ];

  // Our Process
  steps = [
    {
      icon:"icon-tools color1 font-30px",
      title:"Consultation",
      desc:"Nous commençons par une discussion approfondie pour comprendre vos besoins, vos objectifs et votre vision. Cette étape nous permet d'identifier les meilleures solutions adaptées à votre projet."
    },
    {
      icon:"icon-globe color1 font-30px",
      title:"Stratégie",
      desc:"Nous élaborons une stratégie digitale sur mesure, alignée sur vos ambitions. Nous définissons les actions clés à mettre en place pour garantir l'efficacité et la réussite de votre projet."
    },
    {
      icon:"icon-mobile color1 font-30px",
      title:"Réalisation",
      desc:"Nos experts en design, développement et marketing digital transforment votre vision en réalité. Nous concevons des solutions innovantes et performantes qui répondent à vos attentes."
    },
    {
      icon:"icon-browser color1 font-30px",
      title:"Accompagnement",
      desc:"Une fois le projet livré, nous restons à vos côtés pour assurer son évolution et son optimisation. Nous offrons un suivi, des mises à jour et des conseils pour maximiser votre impact digital."
    },
  ]

  // Team
  slideStoreTwo : { title: string; subtitle: string; image: string; index: number }[] = [
    {
      title: "Web Designer",
      subtitle: "Tom Bills",
      image: "team-4.jpg",
      index: 0
    },
    {
      title: "CEO of Becki Agency",
      subtitle: "Sara Adams",
      image: "team-5.jpg",
      index: 1
    }
  ];

  socialLinks = [
    { iconOuter: "facebook", iconInner: ['icofont icofont-social-facebook'] },
    { iconOuter: "twitter", iconInner: ['icofont icofont-social-twitter'] },
    { iconOuter: "pinterest", iconInner: ['icofont icofont-social-pinterest'] },
  ];

  // Services
  services = [
    {
      icon: "icon-tools font-30px white-color",
      title: "Création Graphique",
      desc: "Transformez votre marque avec des visuels captivants. Nos services de création graphique donnent vie à vos idées .",
    },
    {
      icon: "icon-linegraph font-30px white-color",
      title: "Création de Contenue",
      desc: "Faites briller votre message avec du contenu unique. Nos services de création de contenu captivent et engagent.",
    },
    {
      icon: "icon-globe font-30px white-color",
      title: "Création site web/app web",
      desc: "Révélez votre vision avec un site web ou une application web sur mesure. Nos services vous garantissent une présence en ligne exceptionnelle.",
    },
    {
      icon: "icon-tools font-30px white-color",
      title: "Production Visuelle",
      desc: "Chez Digital-Alchemy, nous réalisons des vidéos et photos percutantes pour vos réseaux sociaux et grands événements, capturant chaque moment avec professionnalisme.",
    },
    {
      icon: "icon-beaker font-30px white-color",
      title: "Travaille d'impression",
      desc: "Nous offrons des solutions d'impression haute qualité et de publicité sur lieu de vente (PLV) pour renforcer votre visibilité. De la conception à l'impression, nous créons des supports impactants : flyers, brochures, cartes de visite, roll-ups, enseignes, et plus encore.  ",
    },
    {
      icon: "icon-layers font-30px white-color",
      title: "Media Buying",
      desc: "Chez Digital Alchemy, nous optimisons vos publicités Facebook, Instagram et Google pour atteindre la bonne audience et maximiser votre ROI. Plus de leads, plus de ventes, moins de budget perdu !",
    },
  ]

  // Skills
  skills = [
    { name: 'HTML', level: 90 },
    { name: 'CSS', level: 80 },
    { name: 'JavaScript', level: 85 },
    { name: 'Angular', level: 75 },
    { name: 'TypeScript', level: 70 }
  ];

  isScrolled = false;

  @HostListener('window:scroll', [])
  onScroll(): void {
    const skillsSection = document.querySelector('.skill');
    
    // Add a null check for skillsSection
    if (skillsSection) {
      const position = skillsSection.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      // Check if the section is in view
      if (position < windowHeight) {
        this.isScrolled = true;
      }
    }
  }

  // Portfolio
  portfolios = [
    {
      img: "A.png",
      title: "AIMO ",
      subTitle: "Création Graphique,Création de Contenue,Travaille d'impression,Media Buying"
    },
    {
      img: "B.png",
      title: "NAD AGENCY",
      subTitle: "Branding"
    },
    {


      
      img: "C.png",
      title: "AIMO",
      subTitle: "Création Graphique,Création de Contenue,Création site web"
    },
    {
      img: "D.png",
      title: "DR Abdelaaziz NAITNBAREK",
      subTitle: "Création Graphique"
    },
    {
      img: "E.png",
      title: "Opando",
      subTitle: "Création app web"
    },
    {
      img: "F.png",
      title: "Zenixel",
      subTitle: "Création app web"
    },
    {
      img: "J.png",
      title: "Tiguemi",
      subTitle: "Création Graphique"
    },
    {
      img: "H.png",
      title: "LA TOUCHE DES AMAZIGH",
      subTitle: "Branding"
    }
  ]

  // Pricing
  pricing = [
    {
      title: "Basic Plan",
      subTitle: "An affordable option for end-to-end hiring at small companies.",
      currency: "$",
      amount: 9.99,
      btnClass: "btn btn-dark btn-md btn-default btn-square",
      btnText: "Get Started",
      features: [
        'Mobile-Optimized Website',
        'Powerful Website Metrics',
        'Free Custom Domain',
        '24/7 Customer Support',
        'Fully Integrated E-Commerce',
        'Sell Unlimited Products &amp; Accept Donations',
        'No CMS items',
        'No site search',
        'No CMS API access',
        'No content editors'
      ]
    },
    {
      title: "Extended Plan",
      subTitle: "An affordable option for end-to-end hiring at small companies.",
      currency: "$",
      amount: 24.99,
      btnClass: "btn btn-dark btn-md btn-default btn-square",
      btnText: "Get Started",
      features: [
        'Mobile-Optimized Website',
        'Powerful Website Metrics',
        'Free Custom Domain',
        '24/7 Customer Support',
        'Fully Integrated E-Commerce',
        'Sell Unlimited Products &amp; Accept Donations',
        'No CMS items',
        'No site search',
        'No CMS API access',
        'No content editors'
      ]
    }
  ];

  // Owl Testimonial
  customOptionsThree: OwlOptions = {
    loop: true,
    dots: true,
    margin:30,
    nav:true,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 3,
    navText: ['<i class="icofont icofont-arrow-left"></i>', '<i class="icofont icofont-arrow-right"></i>'],
    responsive:{
      0:{
          items:1,
      },
      600:{
          items:2,
      },
      1000:{
          items:3,
      }
    }
  }

  slideStoreThree = [
    {
      title: "Anne McAdams",
      subTitle: "CEO / Founder",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec sodales nec nulla ac aliquet. Duis vel nunc eget.",
      image: "assets/images/team/avatar-1.jpg",
    },
    {
      title: "Jared Kane",
      subTitle: "CEO / Founder",
      description: "Quisque hendrerit turpis sit amet tortor condimentum, nec commodo lorem condimentum. Sed id diam efficitur, mattis tellus ac, malesuada purus. In ultrices nisl sed eleifend consequat.",
      image: "assets/images/team/avatar-2.jpg",
    },
    {
      title: "Nani Wale",
      subTitle: "CEO / Founder",
      description: "Quisque hendrerit turpis sit amet tortor condimentum, nec commodo lorem condimentum. Sed id diam efficitur, mattis tellus ac, malesuada purus. In ultrices nisl sed eleifend consequat.",
      image: "assets/images/team/avatar-3.jpg",
    },
    {
      title: "John Doe",
      subTitle: "CEO / Founder",
      description: "Quisque hendrerit turpis sit amet tortor condimentum, nec commodo lorem condimentum. Sed id diam efficitur, mattis tellus ac, malesuada purus. In ultrices nisl sed eleifend consequat.",
      image: "assets/images/team/avatar-4.jpg",
    }
  ]

  // Owl Brand Logos
  customOptionsFour: OwlOptions = {
    loop: true,
    dots: false,
    margin:0,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 6,
    responsive:{
      0:{
          items:1,
      },
      600:{
          items:2,
      },
      1000:{
          items:6,
      }
    }
  }

  slideStoreFour = [
    {
      image: "assets/images/clients/1.png",
    },
   
    {
      image: "assets/images/clients/5.png",
    },
    {
      image: "assets/images/clients/6.png",
    },
  
    {
      image: "assets/images/clients/8.png",
    },
   
   

    {
      image: "assets/images/clients/16.png",
    },
    {
      image: "assets/images/clients/17.png",
    },
    {
      image: "assets/images/clients/18.png",
    },
    {
      image: "assets/images/clients/19.png",
    }
  ]

  // EmailJS service configuration (commented out)
  private serviceId = 'contact-form';
  private templateId = 'contact-form-becki';
  private publicKey = 'gObMl0a3V0Jib9k5c';

  socialMedia = [
    {
      iconClass: "fb",
      icon: "icofont icofont-social-facebook",
      url: "https://www.facebook.com/people/Digital-alchemy/61565618420833"
    },
    {
      iconClass: "be",
      icon: "icofont icofont-social-behance",
      url: "https://www.behance.net/digitalalchemy2"
    },
    {
      iconClass: "in",
      icon: "icofont icofont-social-linkedin",
      url: "https://www.linkedin.com/company/digital-alchemy-ma/"
    },
    {
      iconClass: "yt",
      icon: "icofont icofont-social-youtube",
      url: "https://www.youtube.com/@Digital_Alchemy_ma"
    },
    {
      iconClass: "ins",
      icon: "icofont icofont-social-instagram",
      url: "https://www.instagram.com/digital_alchemy_ma/"
    }
  ];

  // Video Popup
  isOpen = false;
  
  openPopup(): void {
    this.isOpen = true;
  }
  
  closePopup(): void {
    this.isOpen = false;
  }

  // Portfolio Modal Functions
  openPortfolioModal(portfolio: any): void {
    this.selectedPortfolio = portfolio;
    document.body.style.overflow = 'hidden';
  }

  closePortfolioModal(): void {
    this.selectedPortfolio = null;
    document.body.style.overflow = '';
  }

  // Get preview image URL (small image for grid)
  getPreviewImageUrl(portfolio: any): string {
    if (portfolio && portfolio.image) {
      // Get base name and add 'preview' suffix
      // Example: portfolio/lawoffice -> portfolio/lawofficepreview.webp
      const baseName = portfolio.image.replace(/\.(png|jpg|jpeg|webp)$/i, '');
      
      // Handle special cases for naming variations
      if (baseName.includes('cardalia')) {
        return `assets/images/portfolio/cardaliaepreview.webp`;
      }
      if (baseName.includes('Kelpreview') || baseName.includes('Kel')) {
        return `assets/images/portfolio/Kelpreview.webp`;
      }
      if (baseName.includes('Lesagumpreview') || baseName.includes('Lesagum')) {
        return `assets/images/portfolio/Lesagumpreview.webp`;
      }
      if (baseName.includes('clic-lighpreview') || baseName.includes('click-light') || baseName.includes('clic-ligh')) {
        return `assets/images/portfolio/clic-lighpreview.webp`;
      }
      if (baseName.includes('projectpreview') || baseName.includes('project')) {
        return `assets/images/portfolio/projectpreview.webp`;
      }
      
      // If already ends with preview, use as is
      if (baseName.endsWith('preview')) {
        return `assets/images/${baseName}.webp`;
      }
      
      return `assets/images/${baseName}preview.webp`;
    }
    return '';
  }

  // Get full image URL (large image for modal)
  // Falls back to preview image if main image doesn't exist
  getWebpImageUrl(portfolio: any): string {
    if (portfolio && portfolio.image) {
      // Get base name and add .webp extension
      const baseName = portfolio.image.replace(/\.(png|jpg|jpeg|webp)$/i, '');
      
      // For projects that only have preview images, use the preview image scaled
      // Check exact image names from portfolio folder
      if (baseName.includes('Kelpreview') || 
          baseName.includes('Lesagumpreview') || 
          baseName.includes('clic-lighpreview') ||
          baseName.includes('projectpreview')) {
        return this.getPreviewImageUrl(portfolio);
      }
      
      // For aimo, check if main image exists (aimo.webp exists)
      if (baseName.includes('aimo') && !baseName.includes('preview')) {
        return `assets/images/${baseName}.webp`;
      }
      
      const mainImageUrl = `assets/images/${baseName}.webp`;
      return mainImageUrl;
    }
    return '';
  }
  
  // Check if project has main image or only preview
  hasMainImage(portfolio: any): boolean {
    if (!portfolio || !portfolio.image) return false;
    const baseName = portfolio.image.replace(/\.(png|jpg|jpeg|webp)$/i, '');
    // Projects that only have preview images (exact names from portfolio folder)
    const previewOnlyProjects = ['Kelpreview', 'Lesagumpreview', 'clic-lighpreview', 'projectpreview'];
    // aimo has main image (aimo.webp exists)
    if (baseName.includes('aimo') && !baseName.includes('preview')) {
      return true;
    }
    return !previewOnlyProjects.some(proj => baseName.includes(proj));
  }

  // Handle image error - fallback to preview image
  handleImageError(event: Event, portfolio: any): void {
    const img = event.target as HTMLImageElement;
    if (img && portfolio) {
      img.src = this.getPreviewImageUrl(portfolio);
      img.classList.add('scale-preview');
    }
  }

  scrollToSection(sectionId: string) {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  }

  portfolioFilters = [
    { label: 'Tous', value: 'all' },
    { label: 'Sites Web', value: 'website' },
    { label: 'E-commerce', value: 'ecommerce' },
    { label: 'Applications', value: 'application' },
    { label: 'Branding', value: 'branding' },
    { label: 'Design', value: 'design' }
  ];

  activeFilter: string = 'all';
  selectedPortfolio: any = null;
  hasMoreProjects: boolean = true;
  displayedProjectsCount: number = 6;

  setActiveFilter(filter: string): void {
    this.activeFilter = filter;
    this.displayedProjectsCount = 6; // Reset to initial count when filter changes
    this.updateHasMoreProjects();
  }

  getFilteredPortfolio(): any[] {
    let filtered = this.activeFilter === 'all' 
      ? this.portfolioItems 
      : this.portfolioItems.filter(item => item.type === this.activeFilter);
    
    return filtered.slice(0, this.displayedProjectsCount);
  }

  loadMoreProjects(): void {
    this.displayedProjectsCount += 6;
    this.updateHasMoreProjects();
  }

  private updateHasMoreProjects(): void {
    const totalFiltered = this.activeFilter === 'all' 
      ? this.portfolioItems.length 
      : this.portfolioItems.filter(item => item.type === this.activeFilter).length;
    
    this.hasMoreProjects = this.displayedProjectsCount < totalFiltered;
  }

  portfolioItems = [
    {
      id: 1,
      title: 'L\'étincelle secrète',
      category: 'Site Web',
      type: 'website',
      description: 'Site web pour gîte romantique avec spa et hammam',
      brief: 'Site web moderne pour location de love room haut de gamme',
      image: 'portfolio/letincelle-secrete',
      technologies: ['WordPress', 'Divi Theme', 'PHP', 'MySQL', 'CSS3'],
      year: '2023',
      fullDescription: 'Site web professionnel pour un gîte romantique privatif de 80m² situé dans le Tarn. Le site présente une love room haut de gamme équipée d\'un spa, hammam, billard, cheminée et chambre secrète. Interface moderne avec système de réservation en ligne intégré, galerie photo, formulaire de contact et présentation des offres & services. Design élégant utilisant le thème Divi avec mise en avant des atouts du lieu et des activités touristiques régionales (Albi, Cordes-sur-Ciel, Najac).'
    },
    {
      id: 2,
      title: 'EnrFath',
      category: 'E-commerce',
      type: 'ecommerce',
      description: 'Plateforme e-commerce complète avec gestion de produits et paiement en ligne',
      brief: 'Site e-commerce moderne avec fonctionnalités avancées',
      image: 'portfolio/EnrFath',
      technologies: ['WooCommerce', 'WordPress', 'PHP', 'MySQL', 'JavaScript'],
      year: '2024',
      fullDescription: 'Plateforme e-commerce complète développée avec WooCommerce et WordPress. Le site inclut une gestion avancée des produits, un système de panier d\'achat, des options de paiement sécurisées, et une interface d\'administration intuitive pour la gestion des commandes et du stock.'
    },
    {
      id: 3,
      title: 'Jasan',
      category: 'Site Web',
      type: 'website',
      description: 'Site web professionnel',
      brief: 'Site web avec design professionnel',
      image: 'portfolio/jasan',
      technologies: ['HTML5', 'CSS3', 'JavaScript'],
      year: '2024',
      fullDescription: 'Site web professionnel avec design soigné et fonctionnalités modernes.'
    },
    {
      id: 4,
      title: 'Disway',
      category: 'E-commerce',
      type: 'ecommerce',
      description: 'Boutique en ligne moderne avec catalogue de produits étendu',
      brief: 'Site e-commerce avec design responsive et optimisé',
      image: 'portfolio/Disway',
      technologies: ['WooCommerce', 'WordPress', 'PHP', 'MySQL', 'CSS3', 'JavaScript'],
      year: '2024',
      fullDescription: 'Boutique en ligne moderne développée avec WooCommerce et WordPress. Le site propose un catalogue de produits étendu, un système de recherche avancé, des filtres de produits, une gestion des avis clients, et une expérience d\'achat optimisée pour mobile et desktop.'
    },
 
    {
      id: 5,
      title: 'Bati',
      category: 'Site Web',
      type: 'website',
      description: 'Site web pour entreprise de construction',
      brief: 'Site web pour le secteur du bâtiment',
      image: 'portfolio/bati',
      technologies: ['HTML5', 'CSS3', 'JavaScript'],
      year: '2024',
      fullDescription: 'Site web professionnel pour entreprise de construction avec présentation des services et réalisations.'
    },
   
    {
      id: 6,
      title: 'Les Vélos au Bord de l\'Eau',
      category: 'Site Web',
      type: 'website',
      description: 'Site web pour location de vélos rétro en Champagne',
      brief: 'Site web moderne pour service de location de vélos vintage',
      image: 'portfolio/velos-champagne',
      technologies: ['WebGazelle CMS', 'PHP', 'MySQL', 'CSS3', 'JavaScript'],
      year: '2024',
      fullDescription: 'Site web professionnel pour un service de location de vélos rétro en Champagne. Implanté à l\'entrée de la voie verte de la Marne (V52) à Magenta, le site présente une collection de vélos vintage du siècle dernier révisés avec soin. Interface moderne avec système de réservation en ligne intégré (Lokki.rent), galerie photo, suggestions d\'itinéraires cyclables, formulaire de contact et gestion multilingue (français/anglais). Design élégant mettant en avant le tourisme doux et la valorisation du paysage viticole champenois. Site hébergé en France avec gestion éco-responsable.'
    },
    {
      id: 7,
      title: 'Sostabib',
      category: 'Site Web',
      type: 'website',
      description: 'Site web pour professionnel de santé',
      brief: 'Site web médical professionnel',
      image: 'portfolio/sostabib',
      technologies: ['HTML5', 'CSS3', 'JavaScript'],
      year: '2024',
      fullDescription: 'Site web professionnel pour professionnel de santé avec interface claire et informative.'
    },



    {
      id: 10,
      title: 'AIMO - Site Vitrine',
      category: 'Site Web',
      type: 'website',
      description: 'Site vitrine responsive avec design moderne et optimisation SEO',
      brief: 'Site vitrine élégant avec présentation des services et portfolio',
      image: 'portfolio/aimo',
      technologies: ['HTML5', 'CSS3', 'JavaScript', 'WordPress'],
      year: '2024',
      fullDescription: 'Développement d\'un site vitrine moderne et responsive pour présenter les services d\'AIMO avec optimisation SEO et interface utilisateur intuitive.'
    },
    {
      id: 11,
      title: 'Cardalia',
      category: 'Site Web',
      type: 'website',
      description: 'Site web moderne et élégant',
      brief: 'Site web avec design moderne',
      image: 'portfolio/cardalia',
      technologies: ['HTML5', 'CSS3', 'JavaScript'],
      year: '2024',
      fullDescription: 'Site web moderne avec interface utilisateur élégante et expérience optimisée.'
    },
   
    {
      id: 12,
      title: 'NAD AGENCY - Identité Visuelle',
      category: 'Design',
      type: 'design',
      description: 'Création d\'une identité visuelle complète et moderne pour NAD Agency',
      brief: 'Branding complet avec logo, charte graphique et supports de communication',
      image: 'portfolio/nad',
      technologies: ['Illustrator', 'Photoshop', 'InDesign'],
      year: '2024',
      fullDescription: 'Conception d\'une identité visuelle forte pour NAD Agency incluant création du logo, charte graphique, supports de communication et déclinaisons digitales.'
    },
   
   
    {
      id: 14,
      title: 'Dr Abdelaaziz NAITNBAREK',
      category: 'Branding',
      type: 'branding',
      description: 'Création graphique pour cabinet médical avec supports de communication',
      brief: 'Design professionnel pour cabinet médical spécialisé',
      image: 'portfolio/doc',
      technologies: ['Photoshop', 'Illustrator', 'InDesign'],
      year: '2023',
      fullDescription: 'Conception de supports de communication pour le cabinet du Dr Abdelaaziz NAITNBAREK incluant cartes de visite, en-têtes de lettres et signalétique.'
    },
    {
      id: 15,
      title: 'Opando - Application Web',
      category: 'Application',
      type: 'application',
      description: 'Application web progressive avec fonctionnalités avancées',
      brief: 'PWA moderne avec interface utilisateur optimisée',
      image: 'portfolio/opando',
      technologies: ['Java', 'Spring Boot', 'Angular', 'TypeScript', 'HTML', 'CSS', 'Docker'],
      year: '2024',
      fullDescription: 'Développement d\'une application web progressive pour Opando avec fonctionnalités avancées, synchronisation offline et interface utilisateur optimisée.'
    },
    {
      id: 16,
      title: 'Zenixel - Plateforme SaaS',
      category: 'Application',
      type: 'application',
      description: 'Plateforme SaaS complète avec dashboard administrateur',
      brief: 'Solution SaaS avec interface d\'administration complète',
      image: 'portfolio/zenixel',
      technologies: ['Java', 'Spring Boot', 'Angular', 'TypeScript', 'HTML', 'CSS', 'Docker'],
      year: '2024',
      fullDescription: 'Création d\'une plateforme SaaS complète pour Zenixel avec dashboard administrateur, gestion des utilisateurs et système de facturation intégré.'
    },
    {
      id: 17,
      title: 'Tiguemi - Identité Graphique',
      category: 'Branding',
      type: 'branding',
      description: 'Création d\'identité graphique unique et mémorable',
      brief: 'Design créatif pour marque lifestyle moderne',
      image: 'portfolio/kell',
      technologies: ['Illustrator', 'Photoshop', 'After Effects'],
      year: '2023',
      fullDescription: 'Développement d\'une identité graphique complète pour Tiguemi incluant logo animé, charte graphique et déclinaisons pour supports digitaux et print.'
    },
    {
      id: 18,
      title: 'LA TOUCHE DES AMAZIGH',
      category: 'Branding',
      type: 'branding',
      description: 'Branding culturel avec respect des traditions amazighes',
      brief: 'Identité visuelle authentique inspirée de la culture amazighe',
      image: 'portfolio/touche',
      technologies: ['Illustrator', 'Photoshop', 'InDesign'],
      year: '2023',
      fullDescription: 'Création d\'une identité de marque authentique pour LA TOUCHE DES AMAZIGH en respectant les codes culturels et en modernisant l\'approche visuelle.'
    },
   
    {
      id: 21,
      title: 'Lesagum - Design Complet',
      category: 'Design',
      type: 'design',
      description: 'Identité de marque complète pour Lesagum avec design moderne et élégant',
      brief: 'Création d\'identité visuelle avec logo, charte graphique et applications',
      image: 'portfolio/Lesagumpreview',
      technologies: ['Illustrator', 'Photoshop', 'InDesign', 'Figma'],
      year: '2024',
      fullDescription: 'Développement d\'une identité de marque complète pour Lesagum incluant création du logo principal et variantes, élaboration d\'une charte graphique détaillée (couleurs, typographie, iconographie), déclinaisons pour supports digitaux (réseaux sociaux, site web, applications mobiles) et supports print (papeterie, packaging, signalétique). L\'identité visuelle reflète l\'élégance et la modernité de la marque avec une palette de couleurs soignée et une typographie distinctive.'
    },
    {
      id: 22,
      title: 'AIMO - Identité de Marque',
      category: 'Design',
      type: 'design',
      description: 'Création d\'identité visuelle professionnelle pour AIMO avec logo et charte graphique',
      brief: 'Design complet avec identité visuelle moderne et applications variées',
      image: 'portfolio/aimo',
      technologies: ['Illustrator', 'Photoshop', 'InDesign', 'After Effects'],
      year: '2024',
      fullDescription: 'Conception d\'une identité de marque complète pour AIMO incluant création du logo avec différentes variantes (horizontal, vertical, monochrome), développement d\'une charte graphique exhaustive avec palette de couleurs, typographie, règles d\'utilisation, déclinaisons pour supports digitaux (réseaux sociaux, site web, emailing) et supports print (papeterie, cartes de visite, en-têtes, présentations). L\'identité reflète le professionnalisme et l\'innovation de la marque avec un design moderne et impactant.'
    },
    {
      id: 23,
      title: 'Tiguemi - Identité Graphique',
      category: 'Design',
      type: 'design',
      description: 'Création d\'identité graphique unique et mémorable pour Tiguemi',
      brief: 'Design créatif pour marque lifestyle moderne avec logo animé',
      image: 'portfolio/Kelpreview',
      technologies: ['Illustrator', 'Photoshop', 'After Effects', 'InDesign'],
      year: '2024',
      fullDescription: 'Développement d\'une identité graphique complète et innovante pour Tiguemi incluant création du logo avec animation, élaboration d\'une charte graphique créative, déclinaisons pour supports digitaux (réseaux sociaux avec animations, site web, applications) et supports print (packaging, merchandising, signalétique). L\'identité reflète l\'esprit lifestyle et moderne de la marque avec des éléments visuels dynamiques et une approche design audacieuse. Le logo animé apporte une dimension interactive à l\'identité de marque.'
    },
    {
      id: 24,
      title: 'Click Light - Design Digital',
      category: 'Design',
      type: 'design',
      description: 'Identité visuelle digitale pour Click Light avec design moderne et lumineux',
      brief: 'Création d\'identité de marque avec focus sur l\'expérience digitale',
      image: 'portfolio/clic-lighpreview',
      technologies: ['Illustrator', 'Photoshop', 'Figma', 'After Effects'],
      year: '2024',
      fullDescription: 'Conception d\'une identité visuelle digitale complète pour Click Light incluant création du logo avec variantes adaptées aux différents contextes digitaux, développement d\'une charte graphique moderne avec palette de couleurs lumineuse et vibrante, déclinaisons optimisées pour supports digitaux (réseaux sociaux, site web responsive, applications mobiles, emailing), animations et micro-interactions pour renforcer l\'identité de marque. L\'identité reflète l\'innovation et la modernité de Click Light avec un design épuré et impactant qui met en valeur le concept de lumière et d\'illumination.'
    },
    {
      id: 20,
      title: 'Manasik Reizen',
      category: 'Site Web',
      type: 'website',
      description: 'Site web pour agence de voyages Hajj et Umrah',
      brief: 'Site web professionnel pour organisation de pèlerinages islamiques',
      image: 'portfolio/manasik',
      technologies: ['PHP', 'MySQL', 'CSS3', 'JavaScript', 'WordPress'],
      year: '2022',
      fullDescription: 'Site web professionnel pour Manasik Reizen, agence de voyages spécialisée dans l\'organisation de pèlerinages Hajj et Umrah depuis plus de 20 ans. Basée à Amsterdam, l\'agence a été désignée comme guide de premier plan pour le Hajj 2024 lors de l\'expo Hajj à Jeddah. Le site propose une présentation complète des forfaits de pèlerinage, système de réservation en ligne, informations pratiques sur les rituels, services d\'accompagnement personnalisé avec guides expérimentés, gestion des visas et hébergements de luxe près des mosquées sacrées. Interface multilingue (néerlandais/anglais) avec chat en direct et formulaire de contact. L\'agence propose également des voyages vers Zanzibar et d\'autres destinations musulmanes.'
    }
  ];


}